function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { Controller } from './Controller';

/**
 * An easy way to add Controller to an UIHandler. Adds getController function to the UI handler.
 * The mixin takes Controller constructor parameters as parameter.
 *
 * @mixin controllerMixin
 * @mixes Controller
 * @example
 * // LoadingHandler.js
 * class UIHandler extends StateHandler {
 *      setLoading (loading) {
 *          this.updateState({ loading });
 *      }
 * };
 * export const LoadingHandler = controllerMixin(UIHandler, ['setLoading']);
 *
 * // LoadingButton.jsx
 * export const LoadingButton = ({loading, controller}) => (
 *     <div>
 *         { loading && <Spin /> }
 *         <Button onClick={() => controller.setLoading(!loading)}>
 *     </div>
 * );
 *
 * // View.js
 * export class View {
 *     constructor () {
 *         this.loadingHandler = new LoadingHandler();
 *         this.loadingHandler.addStateListener(() => this.render());
 *     }
 *     render () {
 *         const state = this.loadingHandler.getState();
 *         const controller = this.loadingHandler.getController();
 *         ReactDom.render(<LoadingButton loading={state.loading} controller={controller} />, document);
 *     }
 * }
 */
export var controllerMixin = function controllerMixin(UIHandler) {
  var functionNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var HandlerWithController = /*#__PURE__*/function (_UIHandler) {
    function HandlerWithController() {
      var _this;
      _classCallCheck(this, HandlerWithController);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, HandlerWithController, [].concat(args));
      var methods = functionNames;
      if (!Array.isArray(methods) || methods.length === 0) {
        methods = [];
        Oskari.log().warn('Controller does not have any methods!');
      }
      _this.controller = new Controller(_this, methods);
      return _this;
    }
    /**
     * @return {Controller} Controller for the handler
     */
    _inherits(HandlerWithController, _UIHandler);
    return _createClass(HandlerWithController, [{
      key: "getController",
      value: function getController() {
        return this.controller;
      }
    }]);
  }(UIHandler);
  return HandlerWithController;
};